export const CUSTOMIZATION_SIDEBAR_SCREEN_PARAMETER =
  'openCustomizationSidebarScreen';
export const GO_PRO_SUCCESS_MODAL_PARAMETER = 'openGoProSuccess';
